import { AuthGuard } from '@emfood/shared';

import { paths } from 'src/routes/paths';

import { ALLOWED_ROLES } from 'src/api/roles-config';

// ----------------------------------------------------------------------

type AppAuthGuardProps = {
  children: React.ReactNode;
  splashScreen: React.ReactNode;
};

export default function AppAuthGuard({ children, splashScreen }: AppAuthGuardProps) {
  return (
    <AuthGuard
      splashScreen={splashScreen}
      loginPath={paths.auth.jwt.login}
      pathOnAuthProblem={paths.auth.jwt.login}
      allowedRoles={[...ALLOWED_ROLES]}
      insufficientRolePath="/insufficient-role"
    >
      {children}
    </AuthGuard>
  );
}
